import { useOnboarding } from "@/hooks/use-onboarding"
import { IonContent, IonIcon, IonPage, IonText } from "@ionic/react"
import { femaleOutline, informationCircleOutline, maleOutline } from "ionicons/icons"
import type React from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { ToggleGroup, ToggleGroupItem } from "../ui/toggle-group"
import { mediumImpact } from "@/utils/capacitorUtils"

const GenderSelection: React.FC<{ nextStep: string; }> = ({ nextStep }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { updateOnboardingData } = useOnboarding()

  const genderOptions = [
    { id: "1", icon: maleOutline, name: "man" },
    { id: "2", icon: femaleOutline, name: "woman" },
  ]

  const handleGenderSelection = async (genderId: string) => {
    mediumImpact()
    await updateOnboardingData({ gender: genderId })
    history.push(nextStep)
  }

  return (
    <IonPage>
      <IonContent scrollY={false}>
        <div
          className="flex flex-col items-center justify-center px-2 bg-card h-full"
        >
          <h1 className="text-2xl font-bold mb-4">{t("gender_selection_title")}</h1>
          <div className="flex items-center text-center text-sm mb-6">
            <span>{t("select_your_gender_body")}</span>
            <IonIcon
              icon={informationCircleOutline}
              className="ml-2 cursor-help"
              onClick={() => alert(t("gender_selection_description"))}
            />
          </div>
          <ToggleGroup variant="outline" size="lg" type="single" className="gap-12">
            {genderOptions.map((gender) => (
              <div key={gender.id} className="flex flex-col items-center">
                <ToggleGroupItem
                  value={gender.id}
                  className="mb-2 block size-28 border-solid border-2 border-input text-3xl md:size-32 bg-input"
                  onClick={() => handleGenderSelection(gender.id)}
                >
                  <IonIcon icon={gender.icon} className="text-5xl" />
                </ToggleGroupItem>
                <IonText className="mt-2 text-lg">{t(gender.name)}</IonText>
              </div>
            ))}
          </ToggleGroup>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default GenderSelection

